import React, { createContext, useContext, useEffect, useState } from "react";
import { content } from "../i18n/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("rq_lang") || "ar");

  useEffect(() => {
    localStorage.setItem("rq_lang", lang);
    const dir = content[lang].dir;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.body.style.fontFamily =
      lang === "ar"
        ? "'Tajawal', sans-serif"
        : "'Poppins', sans-serif";
  }, [lang]);

  const toggleLang = () => setLang((p) => (p === "ar" ? "en" : "ar"));

  const t = content[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, dir: content[lang].dir }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
